import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Type, Layers, Loader2 } from 'lucide-react';
import api from "../../../../api/axios";

const SousCategory = () => {
  const [name, setName] = useState('');
  const [parentId, setParentId] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  // Fetch parent categories
  useEffect(() => {
    api.get("/categories")
      .then((res) => {
        // Assuming the API returns a nested structure, 
        // we only want top-level categories for the parent selection.
        setCategories(res.data.data);
      })
      .catch((err) => console.error(err))
      .finally(() => setFetching(false));
  }, []);


  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!parentId) return alert("Veuillez choisir une catégorie parente");
    
    setLoading(true);
  
    try {
      const response = await api.post('/sous-categories', {
        name: name,
        parent_id: parentId
      });
  
      if (response.data.success) {
        alert('Sous-catégorie créée avec succès !');
        setName('');
        setParentId('');
      }
    } catch (error) {
      // Extract Laravel validation messages
      const errorData = error.response?.data;
      if (errorData?.errors) {
        const messages = Object.values(errorData.errors).flat().join('\n');
        alert(messages);
      } else {
        alert("Une erreur s'est produite.");
      }
    } finally {
      setLoading(false);
    }
  };




  
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="max-w-2xl mx-auto p-6">
      <div className="mb-8">
        <h2 className="text-2xl font-black uppercase tracking-tight text-gray-900">Nouvelle Sous Catégorie</h2>
        <p className="text-sm font-bold text-[#8A8A89] mt-1">ELECTRO TITAN Dashboard</p>
      </div>

      <div className="bg-white rounded-[2.5rem] shadow-xl shadow-gray-200/40 border border-gray-100 p-8 md:p-10">
        <form onSubmit={handleSubmit} className="space-y-6">
          
          {/* Parent Category Select */}
          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-widest text-[#8A8A89] ml-2">Catégorie Parente</label>
            <div className="relative">
              <Layers className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-300" size={18} />
              <select 
                required
                value={parentId}
                onChange={(e) => setParentId(e.target.value)}
                className="w-full pl-12 pr-4 py-4 bg-gray-50 border-none rounded-2xl focus:ring-2 focus:ring-[#ffaa00] outline-none font-bold text-sm transition-all appearance-none"
              >
                <option value="">{fetching ? "Chargement..." : "Sélectionner une catégorie"}</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Sub-Category Name */}
          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-widest text-[#8A8A89] ml-2">Nom de la Sous-Catégorie</label>
            <div className="relative">
              <Type className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-300" size={18} />
              <input 
                required
                type="text" 
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Ex: Machine à laver"
                className="w-full pl-12 pr-4 py-4 bg-gray-50 border-none rounded-2xl focus:ring-2 focus:ring-[#ffaa00] outline-none font-bold text-sm transition-all"
              />
            </div>
          </div>

          <button 
            disabled={loading || fetching}
            type="submit"
            className="w-full py-5 bg-[#ffaa00] text-white rounded-2xl font-black uppercase tracking-[0.2em] text-xs shadow-lg hover:bg-black transition-all flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {loading ? <Loader2 className="animate-spin" /> : 'Enregistrer la Sous-Catégorie'}
            {!loading && <CheckCircle size={18} />}
          </button>
        </form>
      </div>
    </motion.div>
  );
};

export default SousCategory;    